import ConfirmationDlg from "../../../../components/ConfirmationDlg";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../contexts/AuthContext.jsx";
import { renderImage } from "../../../../utils/helper.jsx";
import { toast } from "react-toastify";
import { location, permission, problemType } from "../../../../api";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../components/card/card.jsx";
import NormalInput from "../../../../components/form/HorizontalNormalInput/index.jsx";
import { Form } from "react-bootstrap";
import NormalTextArea from "../../../../components/form/HorizontalNormalTextarea/index.jsx";
import { isPermissionAllowed } from "../../../../components/PermissionChecker/permissionChecker.js";
import { useDashboardContext } from "../../../../contexts/NewDashboardContext.jsx";
function ModalChangeRole({ open, onClose, onSubmit, row }) {
  const { allowedPermissions } = useAuth();
  const { selectedApp } = useDashboardContext();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [locations, setLocations] = useState([]);
  const [serviceGroups, setServiceGroups] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedServiceGroups, setSelectedServiceGroups] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  async function getLocations() {
    try {
      const res = await location.list("", "true");
      if (res.ok) {
        const body = await res.json();
        let data = body.data;

        setLocations(data);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  async function getServiceGroups() {
    try {
      const res = await problemType.list("root", "true");
      if (res.ok) {
        const body = await res.json();
        let data = body.data;

        setServiceGroups(data);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  async function getPermissions() {
    try {
      const res = await permission.list();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;

        const group = Object.groupBy(data, ({ action }) => action);
        setPermissions(group);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  useEffect(() => {
    getLocations();
    getServiceGroups();
    getPermissions();
  }, []);

  useEffect(() => {
    if (open) {
      if (row) {
        setName(row.name);
        setDescription(row.description);
        setSelectedPermissions(
          row.permissions.map((p) => ({ id: p.permission_id }))
        );
        setSelectedLocations(row.accesses ? row.accesses : []);
        setSelectedServiceGroups(row.service_groups ? row.service_groups : []);
      }
    }
  }, [open]);

  async function handleSubmit() {
    //validation
    let errors = [];
    if (!name) {
      errors.push("Enter Role Name");
    }
    if (errors.length > 0) {
      toast.error(errors.join("\n"));
      return;
    }
    onSubmit({
      name,
      description,
      permissions: selectedPermissions,
      accesses: selectedLocations,
      service_groups: selectedServiceGroups,
    });
    if (!row) {
      clearFields();
    }
  }

  function clearFields() {
    setName("");
    setDescription("");
    setSelectedPermissions([]);
    setSelectedLocations([]);
    setSelectedServiceGroups([]);
  }
  async function handleClose() {
    clearFields();
    onClose();
  }

  const handleSelectLocation = (id) => {
    if (selectedLocations.includes(id)) {
      setSelectedLocations((values) => values.filter((v) => v !== id));
    } else {
      setSelectedLocations((values) => [...values, id]);
    }
  };

  const handleSelectServiceGroup = (id) => {
    if (selectedServiceGroups.includes(id)) {
      setSelectedServiceGroups((values) => values.filter((v) => v !== id));
    } else {
      setSelectedServiceGroups((values) => [...values, id]);
    }
  };

  const isSelectedServiceGroup = (id) => {
    return selectedServiceGroups.includes(id);
  };

  const isSelectedLocation = (id) => {
    return selectedLocations.includes(id);
  };

  const selectPermission = (p) => {
    if (selectedPermissions.find((sp) => sp.id == p.id)) {
      const selected = [...selectedPermissions].filter((sp) => sp.id !== p.id);
      setSelectedPermissions(selected);
    } else {
      setSelectedPermissions((prev) => [...prev, p]);
    }
  };

  const isPermissionSelected = (p) => {
    if (selectedPermissions.find((sp) => sp.id == p.id)) {
      return true;
    } else {
      return false;
    }
  };

  let level = 0;

  const renderLocations = (locations, level) => {
    level++;
    return (
      <>
        {locations.map((location, index) => {
          return (
            <div key={index}>
              <div
                className="form-check"
                onClick={() => handleSelectLocation(location.id)}
              >
                <input
                  className="form-check-input"
                  checked={isSelectedLocation(location.id)}
                  type="checkbox"
                  id={`${location.id}`}
                />
                <label className="form-check-label" htmlFor={location.id}>
                  {location.location_name}
                </label>
              </div>
              {level < 3 &&
                location.sublocations &&
                location.sublocations.length > 0 && (
                  <div style={{ marginLeft: "20px" }}>
                    {renderLocations(location.sublocations)}
                  </div>
                )}
            </div>
          );
        })}
      </>
    );
  };

  const renderServiceGroups = (serviceGroups) => {
    return (
      <>
        {serviceGroups.map((serviceGroup, index) => {
          return (
            <div key={index}>
              <div
                className="form-check"
                onClick={() => handleSelectServiceGroup(serviceGroup.id)}
              >
                <input
                  className="form-check-input"
                  checked={isSelectedServiceGroup(serviceGroup.id)}
                  type="checkbox"
                  id={`${serviceGroup.id}`}
                />
                <label className="form-check-label" htmlFor={serviceGroup.id}>
                  {serviceGroup.problem_type_name}
                </label>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <ConfirmationDlg
      open={open}
      size={"lg"}
      btnCancelText="Cancel"
      btnSubmitText={"Submit"}
      onSubmit={handleSubmit}
      onClose={handleClose}
      hideSubmitBtn={
        !isPermissionAllowed(allowedPermissions, selectedApp, ["edit role"])
      }
    >
      <div className="my-2">
        <NormalInput
          onchange={(e) => {
            setName(e.target.value);
          }}
          required
          type="text"
          value={name}
          label={"Name"}
        />
        <NormalTextArea
          onchange={(e) => {
            setDescription(e.target.value);
          }}
          type="text"
          value={description}
          label={"Description"}
        />

        <Card>
          <CardHeader>Location Access</CardHeader>
          <CardBody>
            <div>{renderLocations(locations, level)}</div>
          </CardBody>
        </Card>

        <Card>
          <CardHeader>Service Group Access</CardHeader>
          <CardBody>
            <div>{renderServiceGroups(serviceGroups, level)}</div>
          </CardBody>
        </Card>

        <Card>
          <CardHeader>Permissions</CardHeader>
          <CardBody>
            <div className="d-flex row">
              {Object.entries(permissions).map(([key, value], index) => {
                return (
                  <div key={key} className="col-md-6">
                    <div
                      style={{
                        fontWeight: "bold",
                        textTransform: "capitalize",
                        marginBottom: 5,
                      }}
                    >
                      {" "}
                      {key}
                    </div>

                    {value.map((v) => {
                      return (
                        <Form.Check
                          key={v.id}
                          style={{ textTransform: "capitalize" }}
                          onChange={() => selectPermission(v)}
                          type={"checkbox"}
                          label={v.target}
                          checked={isPermissionSelected(v)}
                        />
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </CardBody>
        </Card>
      </div>
    </ConfirmationDlg>
  );
}

export default ModalChangeRole;
